import { Component, OnInit } from '@angular/core';
import { AuthService, TokenService } from 'src/app/core/services';
import { CommonConstants } from '../../constant';

@Component({
  selector: 'ic-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.scss'],
})
export class BreadCrumbComponent implements OnInit {
  public items: any[];
  public home: any;
  // public store = {
  //   web: false,
  //   webLink: '',
  //   android: false,
  //   androidLink: '',
  //   ios: false,
  //   iosLink: '',
  // } as any;

  constructor(
    private readonly authService: AuthService,
    private readonly tokenService: TokenService
  ) {}

  ngOnInit(): void {
    this.authService.breadCrumb.subscribe((x) => {
      this.items = [];
      this.items = x;
      //this.validate();
    });

    // this.items = [
    //   { label: 'Restaurant Name', routerLink: '/' },
    //   { label: 'Outlet Name' },
    //   { label: 'Page Name' },
    // ];
    this.home = { icon: 'pi pi-home', routerLink: '' };
  }

  // validate() {
  //   const token = this.tokenService.getToken();
  //   if (token.roles === CommonConstants.Role[CommonConstants.Role.Outlet]) {
  //     this.store.web = false;
  //     this.store.android = false;
  //     this.store.ios = false;
  //   } else {
  //     this.store.web = token.restaurantId > 0;
  //     this.store.webLink = token.rest_url;

  //     this.store.android = token.isAndroid;
  //     this.store.androidLink = token.android_url;

  //     this.store.ios = token.isIos;
  //     this.store.iosLink = token.ios_url;
  //   }
  // }
}
